import Ticket from './Ticket'
import BatchResidueValorizationReport from './report/BatchResidueValorizationReport.vue'
import NoFormatWeighingReport from './report/NoFormatWeighingReport'
import WeighingReport from './report/WeighingReport'
import WasteRecoveryReceiptReport from './report/WasteRecoveryReceiptReport'
import { GlobalController } from 'src/shared/global/GlobalController'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'ticket',
    name: 'ticket',
    component: Ticket,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: 'no-format-weighing',
    name: 'noFormatWeighingReport',
    component: NoFormatWeighingReport,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: 'weighing-report',
    name: 'weighingReport',
    component: WeighingReport,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: 'batch-residue-valorization',
    name: 'batchResidueValorizationReport',
    component: BatchResidueValorizationReport,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: 'waste-recovery-receipt',
    name: 'wasteRecoveryReceiptReport',
    component: WasteRecoveryReceiptReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
